// src/components/ThemeToggle.jsx
import React from 'react'
import { useTheme } from '../contexts/ThemeContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from '../i18n'

export default function ThemeToggle() {
  const { isDark, toggle, mounted } = useTheme()
  const { _ } = useTranslation()
  if (!mounted) return null

  const label = isDark ? _('Switch to light mode') : _('Switch to dark mode')

  return (
    <button
      type="button"
      onClick={toggle}
      title={label}
      className="w-full h-full flex items-center justify-center"
      aria-label={label}
    >
      <FontAwesomeIcon icon={isDark ? faSun : faMoon} className="text-xl" />
      <span className="sr-only">{label}</span>
    </button>
  )
}
